import { render, staticRenderFns } from "./SURButton.vue?vue&type=template&id=28fbe176&"
import script from "./SURButton.vue?vue&type=script&lang=js&"
export * from "./SURButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports